enum PurchaseTypes {
  ScanAndPay = 'Scan and Pay',
  OrderAhead = 'Order Ahead',
  TouchlessCoffee = 'Touchless Coffee',
  TouchlessVending = 'Touchless Vending',
}

export default PurchaseTypes;
